import { isAddress } from 'ethers'

export function isValidEthereumAddress(address: string): boolean {
  return isAddress(address)
}
